enum SettingPolicyType {
  TRANSACTION_RECEIPT = "TRANSACTION_RECEIPT",
  TRANSACTION_ATTENDEE = "TRANSACTION_ATTENDEE",
  TRANSACTION_COST_ALLOCATION = "TRANSACTION_COST_ALLOCATION",
  EXPENSE_REIMBURSEMENT = "EXPENSE_REIMBURSEMENT",
  WORKFLOW_APPROVAL = "WORKFLOW_APPROVAL",
  INVOICE_APPROVAL = "INVOICE_APPROVAL",
  PAYMENT_APPROVAL = "PAYMENT_APPROVAL",
  PASSWORD = "PASSWORD",
  REMINDER = "REMINDER",
}

export default SettingPolicyType;
